import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PackagePurchaseModalPage } from './package-purchase-modal.page';
import { PackageCardComponent } from './package-card/package-card.component';

const routes: Routes = [
  {
    path: '',
    component: PackagePurchaseModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PackagePurchaseModalPage, PackageCardComponent]
})
export class PackagePurchaseModalPageModule { }
